module.exports = __webpack_public_path__ + "fonts/1e53f4a.eot";